"use client";

import * as React from "react";
import Stack from "../Stack";
import TabProvider from "./TabContext";
import Tab from "./components/Tab";
import TabPanel from "./components/TabPanel";
import TabPanels from "./components/TabPanels";
import TabList from "./components/TabList";
const Tabs = ({
  children,
  spacing,
  dataTest,
  defaultSelected,
  onChange
}) => {
  return /*#__PURE__*/React.createElement(TabProvider, {
    defaultSelected: defaultSelected,
    onChange: onChange
  }, /*#__PURE__*/React.createElement(Stack, {
    dataTest: dataTest,
    direction: "column",
    spacing: spacing
  }, children));
};
export default Tabs;
export { Tab, TabPanel, TabPanels, TabList };